<template>

    <AppHead title="Studio" />

<!--     <section class="px-4 xl:px-0 mb-16 hidden md:block">
        <SectionHeading title="Create an episode" />
        <div class="grid grid-cols-6 gap-4">
            <div class="aspect-w-4 aspect-h-3">
                <Link :href="route('episodes.create')" class="flex bg-regal-blue-700 text-white flex-col items-center justify-center text-center rounded-lg p-3 hover:bg-regal-blue-800 transition-colors duration-100 ease-in">
                    <div class="mb-3">
                        <PlusCircleIcon class="w-6 h-6" />
                    </div>
                    <div class="text-sm font-medium">
                        New episode
                    </div>
                </Link>
            </div>


        </div>
    </section> -->

    <section class="px-4 xl:px-0 pb-16 pt-6 md:pt-0">
        <SectionHeading title="Podcasts">
            <Button :href="route('episodes.create')" label="Create"/>
        </SectionHeading>

        <div class="grid grid-cols-1 bg-white rounded-2xl divide-y divide-gray-400">
            <PodcastCollection v-for="podcast in podcasts.data" :podcast="podcast" :key="podcast.uuid" :categories="categories"/>
        </div>

        <div v-if="!podcasts.data.length" class="bg-white w-full flex items-center justify-center p-8 rounded-xl">
            <div class="w-auto h-32 md:h-64 flex flex-col space-y-5 items-center justify-center">
                <div class="flex flex-col items-center">
                    <svg class="w-8 h-8 mb-4 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"></path></svg>
                    <div class="text-sm font-medium">
                        No podcasts, yet.
                    </div>
                    <div class="text-gray-700 text-sm text-center">
                        Get started by creating your first podcast.
                    </div>
                </div>
            </div>
        </div>

    </section>

    <section class="px-4 xl:px-0 pb-16 pt-6 md:pt-0">
        <SectionHeading title="Recordings">
            <Button :href="route('recordings.create')" label="Create"/>
        </SectionHeading>
        <div class="flex items-center space-x-4 text-md font-medium">
            <div @click="groupRecordingsBySession = false" :class="[groupRecordingsBySession ? 'text-gray-700 hover:text-regal-blue-900' : 'border-b-regal-blue-700', 'py-1 border-b-2 border-transparent cursor-pointer']">All recordings</div>
            <div @click="groupRecordingsBySession = true" :class="[!groupRecordingsBySession ? 'text-gray-700 hover:text-regal-blue-900' : 'border-b-regal-blue-700', 'py-1 border-b-2 border-transparent cursor-pointer']">Sessions</div>
        </div>
        <div class="grid w-full grid-cols-4 gap-5 mt-4">
            <RecordingSessionCard v-if="groupRecordingsBySession" v-for="session in recordingSessions" :session="session" :key="session.uuid" />
            <RecordingCard v-else v-for="recording in recordings" :recording="recording" :key="recording.uuid" />
        </div>

        <div v-if="!recordingSessions.length" class="bg-white w-full flex items-center justify-center p-8 rounded-xl">
            <div class="w-auto h-32 md:h-64 flex flex-col space-y-5 items-center justify-center">
                <div class="flex flex-col items-center">
                    <svg class="w-8 h-8 mb-4 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"></path></svg>
                    <div class="text-sm font-medium">
                        No recordings, yet.
                    </div>
                    <div class="text-gray-700 text-sm text-center">
                        Get started by creating your first recording.
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script setup>
import { ref, defineProps } from 'vue'
import SectionHeading from '@/Shared/SectionHeading'
import PodcastCard from '@/Shared/PodcastCard'
import Button from '@/Shared/Button'
import Modal from '@/Shared/Modal'
import PodcastForm from '@/Shared/PodcastForm'
import RecordingSessionCard from '@/Shared/RecordingSessionCard'
import RecordingCard from '@/Shared/RecordingCard'
import PodcastCollection from '@/Shared/PodcastCollection'
import {
    PlusCircleIcon,
    DotsCircleHorizontalIcon
} from '@heroicons/vue/outline'
import {
Disclosure,
DisclosureButton,
DisclosurePanel,
} from '@headlessui/vue'

const props = defineProps(['episodes', 'categories', 'templates', 'podcasts', 'recordingSessions', 'recordings'])
const open = ref(false)
const groupRecordingsBySession = ref(false)

</script>

<script>
import Layout from '@/Shared/Layout'

export default {
    layout: Layout,
}
</script>
